import React from 'react';
import { Heading, PropertyGroup } from '../../components';
import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const {
    heading,
    options,
    selectedOptions,
    showUnselectedOptions = true,
    propsForCustomFields,
  } = props;

  // If no heading, options, or content to display, return null
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  // Aggregate all options with isSelected flag across all custom fields
  const allOptionsWithSelection = propsForCustomFields.reduce((acc, item) => {
    const selectedWithDetails = item.options.map(option => ({
      key: option.key,
      label: option.label,
      isSelected: item.selectedOptions.includes(option.key),
    }));
    return acc.concat(selectedWithDetails);
  }, []);

  // Filter for selected options if showUnselectedOptions is false
  const filteredOptions = showUnselectedOptions
    ? allOptionsWithSelection
    : allOptionsWithSelection.filter(option => option.isSelected);

  // Remove duplicates by key, keeping the first occurrence
  const uniqueOptions = Array.from(
    new Map(filteredOptions.map(option => [option.key, option])).values()
  );

  return (
    <section className={css.sectionMultiEnum}>
      {/* <Heading as="h2" rootClassName={css.categoryHeading}>
        {heading}
      </Heading> */}
      <PropertyGroup
        id="ListingPage.amenities"
        options={uniqueOptions}
        selectedOptions={uniqueOptions.filter(option => option.isSelected).map(option => option.key)}
        twoColumns={uniqueOptions.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;